// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.autopayToggle_autopayContainer__RSKeW {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 12px 16px;
  box-sizing: border-box;
}

.autopayToggle_toggleLabel__WA6wt {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  width: 100%;
}

.autopayToggle_toggleInput__w1iAc {
  display: none;
}

.autopayToggle_toggleSwitch__h6rww {
  position: relative;
  width: 44px;
  height: 24px;
  background-color: #353945;
  border-radius: 12px;
  transition: background-color 0.3s ease;
  flex-shrink: 0;
}

.autopayToggle_toggleSwitch__h6rww::before {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #ffffff;
  top: 2px;
  left: 2px;
  transition: transform 0.3s ease;
}

.autopayToggle_toggleInput__w1iAc:checked + .autopayToggle_toggleSwitch__h6rww {
  background-color: #AC87F3;
}

.autopayToggle_toggleInput__w1iAc:checked + .autopayToggle_toggleSwitch__h6rww::before {
  transform: translateX(20px);
}

.autopayToggle_toggleText__aY6Zm {
  font-family: 'Noto Sans', sans-serif;
  flex: 1 1;
}

`, "",{"version":3,"sources":["webpack://./src/components/pwatv/AutopayToggle/autopayToggle.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,QAAQ;EACR,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,SAAO;AACT","sourcesContent":[".autopayContainer {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  box-sizing: border-box;\n}\n\n.toggleLabel {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  cursor: pointer;\n  width: 100%;\n}\n\n.toggleInput {\n  display: none;\n}\n\n.toggleSwitch {\n  position: relative;\n  width: 44px;\n  height: 24px;\n  background-color: #353945;\n  border-radius: 12px;\n  transition: background-color 0.3s ease;\n  flex-shrink: 0;\n}\n\n.toggleSwitch::before {\n  content: '';\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background-color: #ffffff;\n  top: 2px;\n  left: 2px;\n  transition: transform 0.3s ease;\n}\n\n.toggleInput:checked + .toggleSwitch {\n  background-color: #AC87F3;\n}\n\n.toggleInput:checked + .toggleSwitch::before {\n  transform: translateX(20px);\n}\n\n.toggleText {\n  font-family: 'Noto Sans', sans-serif;\n  flex: 1;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"autopayContainer": `autopayToggle_autopayContainer__RSKeW`,
	"toggleLabel": `autopayToggle_toggleLabel__WA6wt`,
	"toggleInput": `autopayToggle_toggleInput__w1iAc`,
	"toggleSwitch": `autopayToggle_toggleSwitch__h6rww`,
	"toggleText": `autopayToggle_toggleText__aY6Zm`
};
export default ___CSS_LOADER_EXPORT___;
